import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

/** @deprecated Use `astral-button` with the appropriate icon and variant in new or Astralized templates. */
@Component({
    selector: 'app-btn-create',
    templateUrl: './btn-create.component.html',
    styleUrls: ['./btn-create.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ButtonCreateComponent {
  @Input() text = 'ADD_MORE';
  @Output() readonly click = new EventEmitter<MouseEvent>();
  @Input() mode: 'add' | 'subtract' = 'add';
  @Input() helpText: string;
  @Input() disabled: boolean = false;

  get modeClass() {
    if (this.mode === 'subtract') return 'btn-subtract';
    return 'btn-create';
  }

  public handleClick(event: MouseEvent) {
    if (!this.disabled) {
      this.click.emit(event);
    }
    event.stopPropagation();
  }
}
